import { render, staticRenderFns } from "./ProductFormTabSeo.vue?vue&type=template&id=4e0eae22&scoped=true"
import script from "./ProductFormTabSeo.vue?vue&type=script&lang=js"
export * from "./ProductFormTabSeo.vue?vue&type=script&lang=js"
import style0 from "./ProductFormTabSeo.vue?vue&type=style&index=0&id=4e0eae22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0eae22",
  null
  
)

export default component.exports